export const MEDSTAR_ASSOCIATION_TYPE__UNKNOWN    = 'UNKNOWN';
export const MEDSTAR_ASSOCIATION_TYPE__ASSOCIATE  = 'ASSOCIATE';
export const MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE = 'PRE-ASSOCIATE';
export const MEDSTAR_ASSOCIATION_TYPE__VENDOR     = 'VENDOR';
export const MEDSTAR_ASSOCIATION_TYPE__STUDENT    = 'STUDENT';
export const MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR = 'CONTRACTOR';
export const MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER = 'BOARD-MEMBER';
export const MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER    = 'VOLUNTEER';

export const medstarAssociationTypeLanguage = {
    [MEDSTAR_ASSOCIATION_TYPE__UNKNOWN] :       {genericName:"unknown"},
    [MEDSTAR_ASSOCIATION_TYPE__ASSOCIATE] :     {genericName:"MedStar Health Associate"},
    [MEDSTAR_ASSOCIATION_TYPE__PRE_ASSOCIATE] : {genericName:"MedStar Health New Hire"},
    [MEDSTAR_ASSOCIATION_TYPE__VENDOR ] :       {genericName:"Vendor"},
    [MEDSTAR_ASSOCIATION_TYPE__STUDENT] :       {genericName:"Student"},
    [MEDSTAR_ASSOCIATION_TYPE__CONTRACTOR] :    {genericName:"Contractor"},
    [MEDSTAR_ASSOCIATION_TYPE__BOARD_MEMBER] :  {genericName:"Board Member"},
    [MEDSTAR_ASSOCIATION_TYPE__VOLUNTEER] :     {genericName:"Volunteer"} 
}
